import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/seo/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/seo/Problem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/seo/WhyNotEnough.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
